import Mask from '../../../../shared/assets/images/png/cardMask.png';
import Screen from '@screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const HorizontalCardMask = styled.img<React.CSSProperties>`
  height: ${200 * Screen.widthRatio}px;
  left: ${119 * Screen.widthRatio}px;
  position: relative;
  top: ${-202 * Screen.widthRatio}px;
  width: ${232 * Screen.widthRatio}px;
`;

HorizontalCardMask.defaultProps = {
  src: Mask,
};

export default withImage(HorizontalCardMask, false);
